import React, { useMemo } from 'react';
import { ErrorMessage, Field, useFormikContext } from "formik";
import InputLabelErrorMessage from "../../../Atomes/Formik/InputLabelErrorMessage";
import ButtonSubmit from "../../../Atomes/Buttons/ButtonSubmit";
import { initialValuesEditUser } from "../../../../config/InitialValues/InitialValuesEditUser";
import MultiSelect from '../../../Atomes/Select/MultiSelect';
import { INTERNAL_ROLES, CATEGORY_OPTIONS, getCategoryLabel } from "../../../../config/UserCategoryConstants";
import { getHighestRole } from "../../../../utils/UserRolesUtils";

function getDisabledCategories(roles) {
	if (!roles || roles.length === 0) {
		return [];
	}
	
	const role = getHighestRole(roles);
	const disabledCategories = [];
	
	if (INTERNAL_ROLES.includes(role)) {
		disabledCategories.push(
			"private-architecte",
			"private-client",
			"pro-property-manager",
			"pro-estate-agency",
			"pro-construction-company",
			"propect"
		);
	} else if (role === "ROLE_CLIENT" || role === "ROLE_ARCH") {
		disabledCategories.push("intern");
	}
	
	return disabledCategories;
}

const CategorySelectField = ({ name, label, roles }) => {
	const disabledCategories = useMemo(() => getDisabledCategories(roles), [roles]);
	
	return (
		<div className={"form-row-label-input"}>
			<label htmlFor={name} className={"text-micro paragraph_bold color-dark-grey"}>{label}</label>
			<Field
				as="select"
				name={name}
				id={name}
				className="select-custom-secondary"
			>
				<option hidden>Sélectionner une catégorie</option>
				{Object.entries(CATEGORY_OPTIONS).map(([key, label]) => {
					const isDisabled = disabledCategories.includes(key);
					return (
						<option 
							key={key} 
							value={key}
							disabled={isDisabled}
							style={isDisabled ? { color: '#ccc', fontStyle: 'italic' } : {}}
						>
							{label}
						</option>
					);
				})}
			</Field>
			<ErrorMessage name={name} component={"p"} className={"color-error text-primary"} />
		</div>
	);
};

const FormEditUserAdminContent = ({ dataRoles, user }) => {

	const { isSubmitting, values } = useFormikContext()

	initialValuesEditUser.user.firstname = user.firstname
	initialValuesEditUser.user.lastname = user.lastname
	if (user.gender === undefined) {
		initialValuesEditUser.user.gender = "NA"
	} else {
		initialValuesEditUser.user.gender = user.gender
	}

	user.agencyName ? initialValuesEditUser.user.agencyName = user.agencyName : initialValuesEditUser.user.agencyName = ""

	initialValuesEditUser.user.phone = user.phone
	initialValuesEditUser.user.email = user.email

	if (user.roles) {
		initialValuesEditUser.user.roles.additionalProp1 = user.roles
	}

	if (user.roleCategory) {
		initialValuesEditUser.user.roleCategory = user.roleCategory
	}

	return (
		<>
			<div className={"form-row-element form-row-two-elements"}>
				<InputLabelErrorMessage type={"select"} label={"Civilité"} name={"user.gender"} keyValue={"value"} keyLabel={"label"} data={[{ value: "M", label: "Monsieur" }, { value: "W", label: "Madame" }, { value: "Miss", label: "Mademoiselle" }, { value: "NA", label: "Non genré" }, { value: "S", label: "Raison sociale" }]} />
				<div style={{display: "flex", gap: "8px"}}>
					<label className={"text-micro paragraph_bold color-dark-grey"} htmlFor='categoryType'>Rôle</label>
					<Field placeholder='Rôle' id={"roles"} component={MultiSelect} options={dataRoles}
										label={"Rôle"} name={"user.roles.additionalProp1"} isMulti={true} />
					<ErrorMessage name={`user.roles.additionalProp1`} component={"p"} className={"color-error text-primary"} />
														
				</div>
			</div>
			{
				values.user.gender === "S" && (
					<div className={"form-row-element"}>
						<InputLabelErrorMessage type={"text"} label={"Raison sociale"} name={"user.agencyName"} />
					</div>
				)
			}
			<div className={"form-row-element form-row-two-elements"}>
				<InputLabelErrorMessage type={"text"} label={"Nom"} name={"user.lastname"} />
				<InputLabelErrorMessage type={"text"} label={"Prénom"} name={"user.firstname"} />
			</div>
			<div className={"form-row-element form-row-two-elements"}>
				<InputLabelErrorMessage type={"text"} label={"Téléphone"} name={"user.phone"} />
				<InputLabelErrorMessage readonly={true} type={"text"} label={"Adresse e-mail"} name={"user.email"} />
			</div>
			<div className={"form-row-element form-row-two-elements"}>
				<CategorySelectField 
					label={"Catégorie"} 
					name={"user.roleCategory"} 
					roles={values.user.roles?.additionalProp1 || user.roles || []}
				/>
			</div>
			<ButtonSubmit styleButton={"btn-default btn-default-secondary plain"} isActive={isSubmitting} title={"Enregistrer"} />
		</>
	);
};

export default FormEditUserAdminContent;
